<template>
  <div id="participaciones" class="">
    <section class="">

      <div class="bannerprincipal pb-2">
      <div class="container">
        <div class="row">
          <div class="col-8 offset-2 col-md-6 offset-md-3 offset-md-0 h-100">
            <div class="">
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class="mt-3 zindex10"
                 
                >
                  <img
                    class="img-fluid"
                    src="../assets/imgs/raspaygana/raspa-y-gana.png"
                    alt="Raspa y Gana"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


      <div class="container">
        <div class="row text-center" v-if="tickets3 != null">
          <div class="col-12 py-3 fXG amarillo bold">
            Mis participaciones
          </div>

          <!-- <div class="col-12 fG text-center bold">
            <p>Tu total de la semana {{semana_corriente}} es de:</p>
            <p>
              <span class="naranja">{{suma_puntos}} puntos</span> en
              <span class="naranja">{{suma_time}}</span>
            </p>
          </div> -->

          <div class="col-12 pb-5 fG blanco text-center">
            Aquí puedes consultar tus participaciones semanales.
          </div>

          <div class="col-12 blanco overflowx ">
            <table class="participaciones table-striped border">
              <thead class="blanco">
                <th>No.</th>
                <th>Nombre</th>
            
                <th>Fecha Registro</th>
                <th>Semana</th>
                <th>Estatus</th>
                <th>Ticket</th>
              </thead>
              <tbody>
                <tr class v-for="(ticket, index) in tickets3" :key="ticket.id">
                  <td>{{ index + 1 }}.</td>
                  <td>{{ userProfile.nombre + " " + userProfile.apellido }}</td>
                  <td>
                    {{ getFechaFormato(ticket.created_on_server.seconds) }}
                  </td>
                  <td>
                    {{
                      ticket.week
                    }}
                  </td>
                   {{ticket.status}}
                  <td>
                    <a :href="ticket.ticket_img_url" target="blank">Ver</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-12 py-5">
            <router-link
              to="/"
              class="btnaction pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Registrar otro ticket
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import { ticketsCollection } from "@/firebase";
import { mapState } from "vuex";
import moment from "moment";
import swal from "sweetalert2";

import * as fb from "../firebase";

import Footer from "@/components/Footer";

const SECONDS_PER_DAY = 86400;
const HOURS_PER_DAY = 24;
const SEMANA_INICIAL = 27;

export default {
  components: {
    Footer,
  },
  data() {
    return {
      post: {
        content: "",
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      file: null,
      monedero: "",
      isRunning: true,
      time: 0,
      time_txt: "",
      suma_puntos: 0,
      suma_time: 0,
      tickets2: [],
      tickets3: null,
      ultimo_ticket: {
        puntos: "",
        time: "",
        time_txt: "",
      },
      ahora: null,
      semana_corriente: "",
    };
  },
  computed: {
    ...mapState(["userProfile", "tickets"]),
  },
  mounted: function () {
    console.log({ userProfile: this.userProfile });
    //this.getTickets();
    this.getTickets2();
  },
  methods: {
    getMultiplicador(puntos) {
      let multiplicador = 1;
      return multiplicador * puntos;
    },
    getTiempoFormato(time) {
      return this.secondsToHms(time);
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    async getTickets2() {
      this.$store.dispatch("showLoader", true);

      const docs = await ticketsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .where("status", "in", ["cerrado", "cerrado en otro ticket", "por validar"])
        .get();

      this.tickets3 = [];
      let thes = this;
      docs.forEach((doc) => {
        let ticket = doc.data();
        ticket.id = doc.id;
        thes.tickets3.push(ticket);
      });
      this.tickets3 = this.tickets3.sort(this.custom_sort);
      console.log({ tickets3_misparticipaciones: this.tickets3 });

      //this.setResumen();

      this.$store.dispatch("showLoader", false);
    },
    custom_sort(a, b) {
      return new Date(a.created_on_server.seconds) - new Date(b.created_on_server.seconds);
    },
    async setResumen() {
      if (this.tickets3.length > 0) {
        this.ultimo_ticket = this.tickets3[this.tickets3.length - 1];
      }
      console.log({ ultimo: this.ultimo_ticket });
      console.log({ ultimo_id: this.ultimo_ticket.id });

      // console.log({ multiplicador: this.tickets });
      //console.log({ userProfile: this.userProfile });
      let multiplicador = 1;

      await this.getAhora();
      this.semana_corriente = this.getNumSemana(this.ahora);
      //console.log({tengoahora: this.ahora});

      let week = this.getSemana(this.ahora);
      //console.log(moment().add(2, "days"));
      //console.log({ weekahora: week });
      let suma_puntos = 0;
      let suma_time = 0;
      this.tickets3.forEach((element) => {
        //console.log({ elem: element.created_on.seconds });
        let date = moment.unix(element.created_on_server.seconds).format("L");
        //console.log(date);
        //console.log(moment(date).week());
        let temp_week = moment(date).add(2, "days").week();
        //console.log({ weektemp: temp_week });
        if (week == temp_week) {
          suma_puntos = suma_puntos + parseInt(element.puntos);
          suma_time = suma_time + parseInt(element.time);
        }
      });

      this.suma_puntos = suma_puntos * multiplicador;
      this.suma_time = this.secondsToHms(suma_time);
    },
    secondsToHms(seconds) {
      const days = Math.floor(seconds / SECONDS_PER_DAY);
      const remainderSeconds = seconds % SECONDS_PER_DAY;
      const hms = new Date(remainderSeconds * 1000)
        .toISOString()
        .substring(11, 19);
      return hms.replace(/^(\d+)/, (h) =>
        `${Number(h) + days * HOURS_PER_DAY}`.padStart(2, "0")
      );
    },
    getNumSemana(fecha) {
      let semana = parseInt(this.getSemana(fecha)) - SEMANA_INICIAL;
      
      return semana;
    },
    getSemana(fecha) {
      return moment(fecha).add(2, "days").week();
    },
    async getAhora() {
      this.$store.dispatch("showLoader", true);
      var thes = this;
      //fb.functions.useFunctionsEmulator('http://localhost:5000')
      var getFecha = fb.functions.httpsCallable("getAhora");

      let res = null;
      await getFecha("{}")
        .then(function (result) {
          // Read result of the Cloud Function.
          console.log({ resultadoGetAhora: result });
          thes.ahora = thes.getFechaFormato(result.data._seconds);
          //console.log({ahora: thes.ahora})
        })
        .catch(function (error) {
          console.log({ errorgetahora: error });
        });

      this.$store.dispatch("showLoader", false);
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }

      let date = val.toDate();
      return moment(date).fromNow();
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
